<template>
  <AuthPage>
    <AuthFormWrapper class="px-6 md;px-0">
      <AuthFormHeading>Sign in to 64 Analytics</AuthFormHeading>
      <FormKit
        type="form"
        @submit="onSignIn"
        submit-label="Log In"
        :submit-attrs="{
          inputClass: 'w-full flex justify-center',
          wrapperClass: 'w-full',
          'data-theme': `dark`,
          ignore: false,
        }"
      >
        <FormKit
          type="email"
          name="email"
          id="email"
          label="Email Address"
          help="The email address registered to your 64 Analytics account"
          placeholder="your@email.com"
          validation="required|email"
          v-model="email"
        />
        <FormKit
          type="password"
          name="password"
          id="password"
          label="Password"
          help="The password you used to register your 64 Analytics account"
          placeholder="Your password"
          validation="required"
          v-model="password"
        />
      </FormKit>

      <p class="text-center">
        <NuxtLink class="underline" :to="{ path: '/reset-password' }">Password Reset</NuxtLink>
      </p>
      <p class="text-center">
        Still need to sign up?
        <NuxtLink class="underline" :to="{ path: '/sign-up' }">Get Started</NuxtLink>
      </p>
    </AuthFormWrapper>
    <UModal v-model="checkEmailNotification">
      <div class="p-4">
        <HeadingBasic :size="2">Please check your email</HeadingBasic>
        <p class="mt-5 mb-10">
          Your email has not yet been confirmed. Please check your email (including spam) and click
          the link in the email from <strong>"64 Analytics"</strong> to confirm your email address
        </p>
        <UButton label="Get Support" @click="onStartChat"></UButton>
        <UButton
          class="ml-3"
          color="white"
          label="Close"
          @click="checkEmailNotification = false"
        ></UButton>
      </div>
    </UModal>
  </AuthPage>
</template>

<script setup lang="ts">
import { type AuthChangeEvent } from '@supabase/gotrue-js/src';
import { FormKit } from '@formkit/vue';
definePageMeta({
  middleware: 'redirect-if-logged-in',
});
useHead({
  title: 'Log in',
});
const supabase = useSupabaseClient();
const store = useProfileStore();
const { fetchProfile } = store;
const toast = useToast();
const email = ref('');
const password = ref('');
const {
  public: { baseUrl },
} = useRuntimeConfig();

supabase.auth.onAuthStateChange((event: AuthChangeEvent) => {
  // console.log('onAuthStateChange :: ', event);
  // toast.add({ title: `Auth state changed: ${event}`, color: 'blue' });
});
const checkEmailNotification = ref(false);
const onSignIn = async () => {
  const {
    data: { user },
    error,
  } = await supabase.auth.signInWithPassword({
    email: email.value,
    password: password.value,
  });
  if (user) {
    // Make sure the profile including subscription info get populated into the store before we go to my account
    await fetchProfile(user);
    navigateTo('/my-account');
  }
  if (error) {
    toast.add({ title: `There was an issue logging in: ${error.message}`, color: 'red' });
    if (error.message.includes('Email not confirmed')) {
      checkEmailNotification.value = true;
    }
  }
};
const onStartChat = () => {
  window.Intercom('showNewMessage', 'I am having trouble signing in after checkout.');
};
</script>

<style lang="scss">
form {
  @apply w-full;
}
</style>
